/** User-facing errors for Pollie / State IQ Celery jobs. */

export const INTERACTIVE_JOB_TIMEOUT_MS = 420000;

export function interactiveJobErrorMessage(err) {
  if (err?.code === 'POLL_CANCELLED') {
    return '';
  }
  const pollMsg = err?.message || '';
  if (pollMsg.includes('longer than expected')) {
    return 'This is taking too long. Try a narrower question or try again in a moment.';
  }
  const apiErr = err?.response?.data?.error;
  if (typeof apiErr === 'string' && apiErr.trim()) {
    return apiErr.trim();
  }
  if (err?.response?.data?.status === 'failed') {
    const fail = err.response.data.error || '';
    if (/time limit/i.test(fail)) {
      return fail;
    }
  }
  return 'That ask could not finish. Try again in a moment, or try a narrower question.';
}
